<template>
  <Btn
    :tag="tag"
    variant="bare"
    :class="classNames"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </Btn>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    size: {
      type: String,
      default: null,
    },
  },

  computed: {
    classNames() {
      return ['badge', { [`badge--${this.size}`]: !!this.size }];
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  margin: 2px 3px 2px 0;
  padding: 3px 13px;
  display: inline-block;

  background-color: $alt-100;
  border-radius: 24px;

  font-size: rem(13px);
  line-height: 24px;

  cursor: default;
}

a.badge,
button.badge {
  cursor: pointer;

  &:not(:disabled) {
    &:hover,
    &:focus {
      background-color: darken($alt-100, 5%);
    }
  }
}

.badge--small {
  padding: 0 9px;

  font-size: rem(11px);
}
</style>
